<template>
  <div class="wrapper">
    <ul class="current_user">
      <li>姓名：{{ selectdata.patientname }}</li>
      <li>就诊ID号：<span>{{ selectdata.patientId }}</span></li>
      <!-- <li>身份证：<span>{{ selectdata.idcardno.replace(/(\w{4})\w*(\w{4})/, "$1******$2") }}</span></li> -->
      <span @click="showNation = true" class="switch">切换就诊人</span>
      <img src="@/assets/record/jkm2.png" @click.stop="cardbtn(selectdata)"/>
    </ul>
    <div class="rrtop" @click="showChoice = true"  v-show="showList">
      <span>{{ select }}</span>
      <van-icon name="arrow-down" />
    </div>
    <van-divider v-show="showList" />
    <ul class="zydetails" v-show="showList">
      <li>
        <span>住院科室</span>
        <span>{{ hisdata.deptName }}</span>
      </li>
      <li>
        <span>床号</span>
        <span>{{ hisdata.bedNo?hisdata.bedNo:"无" }}</span>
      </li>
      <li>
        <span>主治医生</span>
        <span>{{ hisdata.doctorName }}</span>
      </li>
      <li>
        <span>入院时间</span>
        <span>{{ hisdata.inpDatetime }}</span>
      </li>
      <li>
        <span>住院号</span>
        <span>{{ hisdata.inpNo }}</span>
      </li>
      <li>
        <span>病人姓名</span>
        <span>{{ hisdata.patientName }}</span>
      </li>
    </ul>
    <ul class="rrlist" v-show="showList">
      <li v-for="item in recordList" :key="item.hisTranNo">
        <span>充值（{{ item.payTag }}）</span>
        <span>{{ item.operDateTime }}</span>
        <span>{{ item.amt }} 元</span>
      </li>
    </ul>
    <div class="empty_cl" v-show="!showList">
      <van-empty
        class="custom-image"
        image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
        description="无充值记录"
      />
    </div>
    <van-popup v-model="showChoice" round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirmNation"
        @cancel="showChoice = false"
      />
    </van-popup>
    <van-popup v-model="showNation" round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns2"
        @confirm="onConfirmNation2"
        @cancel="showNation = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { getIpPatient, getInDepositView, selectVisitinfos } from "@/request/api.js";
import { Dialog } from "vant";
export default {
  data(){
    return{
      selectdata: {
        idcardno: ""
      },
      card: {},
      showList: false,
      historyList: [],
      showChoice: false,
      showNation: false,
      columns: [],
      columns2: [],
      hisdata: {},
      select: "最近一次",
      recordList: []
    }
  },
  created() {
    this.card = JSON.parse(sessionStorage.getItem("card"));
    this.getVisitinfos();
    // this.getInfo()
  },
  methods: {
    // 获取所有就诊人
    async getVisitinfos() {
      let openid = sessionStorage.getItem("openid");
      let res = await selectVisitinfos({ openid });
      this.columns2 = res.data.obj;
      res.data.obj.forEach(item => {
        item.text = item.patientname;
        if (item.style == 1) {
          this.selectdata = item;
        }
      });
      this.getInfo();
    },
    // 切换就诊卡
    onConfirmNation2(value) {
      this.selectdata = value;
      this.showNation = false;
      this.getInfo();
      this.Toast("切换成功");
    },
    // 查看电子卡
    cardbtn(item){
      sessionStorage.setItem("card", JSON.stringify(item));
      this.$router.push("/HealthCard");
    },
    // 获取就诊人住院信息
    async getInfo() {
      if(!this.selectdata.patientId){
        Dialog.alert({
          message: "请前往设置默认就诊人"
        }).then(() => {
          this.$router.push("/MedicalCard");
        });
        return;
      };
      let map = {
        patientId: this.selectdata.patientId,
        // patientId: "151442",
        // patientId: "874682",
        // patientId: "24813",
        userId: "7148"
      };
      let res = await getIpPatient(map);
      if(res.data.obj.resultData == null){
        this.showList = false
        return;
      } else {
        this.showList = true
        res.data.obj.resultData.forEach(item => {
          // item.inpDatetime = item.inpDatetime.replace(/\s{2}/g," ");
          // item.inpDatetime = item.inpDatetime.split(" ")
          // item.inpDatetime = item.inpDatetime[2] +'-'+ item.inpDatetime[0].toString().padStart(2,'0') +'-'+ item.inpDatetime[1].toString().padStart(2,'0')
          if (!item.outtime) {
            this.info = item;
            item.outtime = "未出院"
          } else {
            // item.outtime = item.outtime.replace(/\s{2}/g," ");
            // item.outtime = item.outtime.split(" ")
            // item.outtime = item.outtime[2] +'-'+ item.outtime[0].toString().padStart(2,'0') +'-'+ item.outtime[1].toString().padStart(2,'0')
          }
        });
        this.historyList = res.data.obj.resultData.reverse();
        for(let i=this.historyList.length;i>=1;i--){
          if(i == this.historyList.length){
            this.columns.push("最近一次")
          } else {
            this.columns.push(`第${i}次`)
          }
        }
        this.hisdata = this.historyList[0]
        this.rechargeQuery()
      }
    },
    // 充值记录查询
    async rechargeQuery(){
      let map = {
        endDate: this.hisdata.inpDatetime.slice(0,10),
        inpNo: this.hisdata.inpNo,
        inpNum: this.hisdata.inpNum,
        patientID: this.hisdata.patientID,
        startDate: this.hisdata.outtime.slice(0,10)
      }
      let res = await getInDepositView(map);
      if(res.data.obj.resultData != null){
        this.recordList = res.data.obj.resultData;
      }
    },
    onConfirmNation(value) {
      let num = "";
      this.select = value
      if(value == "最近一次"){
        num = this.historyList.length
      } else {
        num = value.slice(1,2)
      }
      this.historyList.forEach(item => {
        if(item.inpNum == num){
          this.hisdata = item
        }
      })
      this.showChoice = false;
      this.rechargeQuery();
    },
  },
}
</script>

<style lang="less" scoped>
.wrapper{
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #f8f8f8;
  .current_user{
    position: relative;
    margin: 4px 4px 2px 4px;
    padding: 10px;
    background: #E6F5FC;
    border-radius: 6px;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 1px;
    >li{
      >span{
        letter-spacing: 0px;
      }
    }
    >li:nth-child(2){
      margin: 10px 0px;
    }
    .switch{
      position: absolute;
      top: 10px;
      right: 20px;
      color: #6098ff;
    }
    >img{
      position: absolute;
      width: 40px;
      right: 46px;
      bottom: 10px;
    }
  }
  .zydetails{
    display: flex;
    flex-flow: column nowrap;
    margin: 4px;
    background: #FFF;
    border-radius: 10px;
    padding: 0px 20px 10px;
    >li{
      margin-top: 10px;
      font-size: 16px;
      letter-spacing: 1px;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: space-between;
      >span:nth-child(1){
        font-weight: bold;
      }
      >span:nth-child(2){
        color: #8b8b8b;
      }
    }
  }
  .rrtop{
    display: inline-block;
    margin: 6px 20px;
    font-size: 20px;
    >span{
      margin-right: 4px;
    }
    /deep/ .van-icon{
      position: relative;
      top: 3px;
      left: -3px;
    }
  }
  /deep/ .van-divider{
    margin: 0px;
    border-color: black;
  }
  .rrlist{
    margin: 0 4px;
    padding: 0px 20px;
    display: flex;
    flex-flow: column nowrap;
    background: #fff;
    >li {
      position: relative;
      padding: 16px 0px;
      border-bottom: 1px solid #ddd;
      display: flex;
      flex-flow: column nowrap;
      >span:nth-child(1){
        font-size: 18px;
        letter-spacing: 1px;
        margin-bottom: 2px;
      }
      >span:nth-child(2){
        margin-top: 4px;
        color: #999;
      }
      >span:nth-child(3){
        position: absolute;
        right: 4px;
        top: 28px;
        font-size: 20px;
      }
    }
  }
  .empty_cl{
    letter-spacing: 1px;
    /deep/ .van-empty__description{
      font-size: 18px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Index/Deposit/RechargeRecord.vue